import SigninForm from '@/components/main/signin/signin-form/signinForm'

import Content from '@/components/layout/content'
import { StyledMedia, StyledSignin } from './style'
import { SEO } from '@/components/seo/seo'

export const SigninContainer = () => {
  return (
    <>
      <SEO
        title="로그인"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/notice"
        noIndex={true}
      />
      <Content fullHeight>
        <StyledMedia>
          <StyledSignin>
            <SigninForm />
          </StyledSignin>
        </StyledMedia>
      </Content>
    </>
  )
}
